export default "__VITE_ASSET__c39ad2cf__"